module.exports = __webpack_public_path__ + "Images/w_performance.png";


//////////////////
// WEBPACK FOOTER
// ./Images/w_performance.png
// module id = 814
// module chunks = 2